import { TimesheetsSummaryConfigItemType } from '@/api/types/general/TimesheetsType'
import { TimesheetsTotalResponseType } from '@/api/types/response/TimesheetsResponseType'
import { TimesheetStatusEnum } from '@/utilities/timesheets/status/enums/TimesheetStatusEnum'
import TimesheetsTotalResponseFormatterInterface from '@/utilities/timesheets/total/interfaces/TimesheetsTotalResponseFormatterInterface'

export default class TimesheetsTotalResponseFormatter<T extends TimesheetsTotalResponseType = TimesheetsTotalResponseType>
  implements TimesheetsTotalResponseFormatterInterface {
  private readonly response: T

  constructor(response: T) {
    this.response = response
  }

  withStatusName(items: TimesheetsSummaryConfigItemType[]): TimesheetsSummaryConfigItemType[] {
    const { status } = this.settings()

    return items.map(item => ({
      ...item,
      name: status.find(({ id }) => id === item?.id)?.name ?? TimesheetStatusEnum.Open,
    }))
  }

  summary(): T['data']['data']['totals'] {
    const { totals } = this.response.data.data

    return totals.map(item => ({
      ...item,
      time: this.withStatusName(item.time),
      quantity: this.withStatusName(item.quantity),
    }))
  }

  settings(): T['data']['data']['settings'] {
    return this.response.data.data.settings
  }
}
